export enum Regex {
  Phone = '^(?:4|9)\\d{7}$',
  IMEI = '^[0-9]+$',
  ICC = '^8947[0-9]*$',
  YouTubeVideoId = '(?:https?:\\/{2})?(?:w{3}\\.)?youtu(?:be)?\\.(?:com|be)(?:\\/watch\\?v=|\\/)([^\\s&]+)',
  Email = "^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(\\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@([a-zA-Z0-9]([a-zA-Z0-9-]*[a-zA-Z0-9])?\\.)+[a-zA-Z]{2,}$",
  IllegalCharacter = '[0-9#%&$\\:\\?!\\{\\|\\}[\\]()<>*,+\\/=\\_""]+',
  PostCode = '^[0-9]{4}$',
  ID_Card = '^(?:[A-Za-z]{2}\\d{7}|[A-Za-z]{3}\\d{6})$',
  Passport = '^[A-Za-z0-9]{8,9}$',
  DrivingLicense = '^\\d{11,12}$',
  EID = '^[0-9]{32}$',
}
